export default __webpack_public_path__ + "static/media/st_john_icon.112195b6.jpg";